import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { Tabs } from "antd";
import dayjs from "dayjs";
import { getAllShifts } from "../../redux/actions/shift";
import { getAllAmbulanceMappings } from "../../redux/actions/ambulanceEmployeeMapping";
import { getAttendanceShifts } from "../../redux/actions/attendanceShifts";
import { getAllZonesApi } from "../../apis/districts";
import Attendance from "./Attendance";
import FilterPanel from "./filterPanel";

const AttendanceDashboard = () => {
  const dispatch = useDispatch();
  const [zones, setZones] = useState([]);
  const [currentUser] = useState(() => JSON.parse(localStorage.getItem("currentUser")));
  const isOpsManager = currentUser?.role === "OPERATION_MANAGER";
  const userTenantId = currentUser?.tenant?.id || null;
  const userZoneId = !userTenantId && isOpsManager ? currentUser?.zone?.id : null;
  const allShifts = useSelector((state) => state.shift.data);
  const attendanceShift = useSelector((state) => state.attendanceShift.data);
  const isLoading = useSelector(
    (state) => state.shift.isProcessing || state.attendanceShift.isProcessing
  );

  const [shiftPagination, setShiftPagination] = useState({
    page: 1,
    pageSize: 10,
    total: 0,
  });
  const [attendancePagination, setAttendancePagination] = useState({
    page: 1,
    pageSize: 10,
    total: 0,
  });

  const [shiftFilters, setShiftFilters] = useState({});
  const [attendanceFilters, setAttendanceFilters] = useState(() => {
    const user = JSON.parse(localStorage.getItem("currentUser"));
    const base = {
      fromDate: dayjs().subtract(1, "day").format("YYYY-MM-DD"),
      toDate: dayjs().subtract(1, "day").format("YYYY-MM-DD"),
    };
    if (user?.tenant?.id) base.tenantId = user.tenant.id;
    else if (user?.role === "OPERATION_MANAGER" && user?.zone?.id) base.zoneId = user.zone.id;
    return base;
  });

  // 🔹 Separate trigger flag for download (not in filters)
  const [shouldDownload, setShouldDownload] = useState(false);

  const [activeTab, setActiveTab] = useState("2");

  useEffect(() => {
    getAllZonesApi().then((res) => { if (res) setZones(res); });
  }, []);

  // Normal attendance fetch — runs on page/filter change only
useEffect(() => {
  dispatch(
    getAttendanceShifts({
      page: attendancePagination.page - 1,
      size: attendancePagination.pageSize,
      ...attendanceFilters,
    })
  );
}, [dispatch, attendancePagination.page, attendancePagination.pageSize, attendanceFilters]);

// Separate effect for download
useEffect(() => {
  if (shouldDownload) {
    dispatch(
      getAttendanceShifts({
        page: attendancePagination.page - 1,
        size: attendancePagination.pageSize,
        ...attendanceFilters,
        downloadFile: true,
      })
    );
    setShouldDownload(false);
  }
}, [shouldDownload]);

  // 🔸 Update total counts
  useEffect(() => {
    setShiftPagination((prev) => ({
      ...prev,
      total: allShifts.totalCount || 0,
    }));
    setAttendancePagination((prev) => ({
      ...prev,
      total: attendanceShift.totalCount || 0,
    }));
  }, [allShifts.totalCount, attendanceShift.totalCount]);

  const items = [
    {
      key: "2",
      label: "Attendance",
      children: (
        <Attendance
          attendanceShift={attendanceShift.object || []}
          pagination={attendancePagination}
          onPageChange={(page) =>
            setAttendancePagination((prev) => ({ ...prev, page }))
          }
          onPageSizeChange={(size) =>
            setAttendancePagination({
              page: 1,
              pageSize: size,
              total: attendancePagination.total,
            })
          }
          loading={isLoading}
        />
      ),
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      <FilterPanel
        filterType={activeTab === "1" ? "shift" : "attendance"}
        filters={activeTab === "1" ? shiftFilters : attendanceFilters}
        onFilter={(filters) => {
          if (activeTab === "1") {
            setShiftPagination((prev) => ({ ...prev, page: 1 }));
            setShiftFilters(filters);
          } else {
            setAttendancePagination((prev) => ({ ...prev, page: 1 }));
            const user = JSON.parse(localStorage.getItem("currentUser"));
            const scoped = { ...filters };
            if (user?.tenant?.id) scoped.tenantId = user.tenant.id;
            else if (user?.role === "OPERATION_MANAGER" && user?.zone?.id) scoped.zoneId = user.zone.id;
            setAttendanceFilters(scoped);
          }
        }}
        onDownloadReport={() => setShouldDownload(true)}
        zones={zones}
        zoneId={userZoneId}
        zoneDisabled={isOpsManager}
      />

      <Tabs
        defaultActiveKey="2"
        activeKey={activeTab}
        onChange={setActiveTab}
        items={items}
        destroyInactiveTabPane={false}
      />
    </div>
  );
};

export default AttendanceDashboard;
